import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { TranslateAppService } from '../app-services/translate-app.service';
import { CustomerAppService } from '../app-services/customer-app.service';

@Injectable({
  providedIn: 'root'
})
export class LoggdInGuard implements CanActivate {

  constructor(
    private customerAppService: CustomerAppService,
    private router: Router,
    private translateAppService: TranslateAppService) {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.customerAppService.hasLoggedIn) {
      // home
      this.router.navigate([this.translateAppService.getUrl('/')]);
    }
    return true;
  }

}
